module.exports = __webpack_public_path__ + "img/home-second-5.30005f37.jpg";